<template>
  <div>
    <van-nav-bar :border="false"
                 title="消息"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="list-message-wrap">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"
        >
          <div tag="div" class="item" @click="toDetail(item.Item.Sysno,index)" v-for="(item,index) in msgList" :key="index">
            <div class="title" :class="{'unread':item.ItemStatus.Sysno=='MSGS4'?false:true}">{{ item.ItemStatus.Name }}：{{ item.Item.Name }}</div>
            <!-- <p>北京大学学生公寓北京大学学生公寓招标项目需要您的审核，项目时间2021年招标项目需要您的审核，项目时间2021年</p> -->
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msgList: [],
      page: 1,
      pcount: 20,
      allcount: 0,
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  mounted() {
    // this.WebGetMsgInfoLst()
  },
  beforeCreate() {
    document.querySelector('body').className = 'fff'
  },
  destroyed() {
    document.querySelector('body').className = ''
  },
  methods: {

    onLoad() {
      this.WebGetMsgInfoLst();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.msgList = [];
      this.onLoad()
    },
    // 消息列表
    WebGetMsgInfoLst() {
      let data = {
        UserSysno: localStorage.getItem('UserSysno'),
        page: this.page,
        pcount: this.pcount
      }
      // if(localStorage.getItem('isBoss')==1){
      //     data = {
      //         page: this.page,
      //         pcount: this.pcount
      //     }
      // }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebGetMsgInfoLst', data, res => {
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.loading = false
        console.log(res);
        res = res.WebGetMsgInfoLstResult
        if (res.ResponseCode == 1) {
          this.allcount = res.AllCount;
          if (res.ItemLst) {
            this.msgList.push(...res.ItemLst)
          }
          if (this.msgList.length >= this.allcount) {
            this.finished = true
          } else {
            this.page++
          }
          // 位置保存
          // setTimeout(()=>{
          //     if(window.targetPosition){
          //         window.scrollTo(window.targetPosition.x, window.targetPosition.y);
          //     }
          // },0);
        } else {
          this.finished = true
        }
      }, err => {
      })
    },
    toDetail(sysno, index) {
      this.msgList[index].ItemStatus.Sysno = 'MSGS4'
      this.$router.push({
        name: 'MessageDetail',
        params: {
          sysno
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
.list-message-wrap {
  padding: 0.28rem;

  .item {
    padding: .3rem .18rem;
    border-bottom: 1px solid #ddd;
    font-size: 0.32rem;
    color: #888888;

    .title {
      font-size: 0.4rem;
      color: #333333;
      margin-bottom: 0.08rem;

      &.unread:before {
        content: '';
        display: inline-block;
        margin-right: 0.16rem;
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 100%;
        background-color: #ff7200;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/Message.vue